import { Http, RequestOptions, Headers, Response } from '@angular/http';
import { Injectable } from '@angular/core';
import { GlobalServiceProvider } from '../global-service/global-service';
import 'rxjs/add/operator/toPromise';
import { IXOM } from '../../model/ixom';


/*
  Generated class for the IxomProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class IxomProvider {
  ixomBasURL: String = this.globalServiceProvider.appConfig.ixomApiUrl;
  ixoms: Array<IXOM> = [];
  ixomsSchedule: Array<IXOM> = [];
  constructor(
    public http: Http,
    public globalServiceProvider: GlobalServiceProvider,
  ) {
    console.log('Hello IxomProvider Provider');
  }

  async getIxomByJob(jobNo: number) {
    return new Promise<any[]>((resolve: any, reject: any) => {      
      let uri = `${this.ixomBasURL}/ixom/api/v2/ixomsbyjob?fk_Job=${jobNo}`;
      let result = null;
      return this.http
        .get(uri)
        .toPromise()
        .then(data => {
          result = data.json();
          resolve(result);
        })
        .catch(          
          err => {
            resolve([]);
          }
        )
    });
  }


  getIDashboardJob(date: string, custCode: string, isSiteAcc: boolean) {
    return new Promise<Array<IXOM>>((resolve: any, reject: any) => {      
      let uri = `${this.ixomBasURL}/ixom/api/v2/dashboard`;
      let result = null;
      return this.http
        .get(uri, { params: { date: date, custCode: custCode, isSiteAcc: isSiteAcc } })
        .toPromise()
        .then(data => {
          result = data.json();
          resolve(result);
        })
        .catch(          
          err => {
            resolve([]);
          }
        )
    });
  }

  getSchedule(startDate: string, endDate: string, custCode: string, isSiteAcc: boolean) {
    return new Promise<Array<IXOM>>((resolve: any, reject: any) => {      
      let uri = `${this.ixomBasURL}/ixom/api/v1/schudele`;
      let result = null;
      return this.http
        .get(uri, { params: { startDate: startDate, endDate: endDate, custCode: custCode, isSiteAcc: isSiteAcc } })
        .toPromise()
        .then(data => {
          result = data.json();
          resolve(result);
        })
        .catch(          
          err => {
            resolve([]);
          }
        )
    });
  }

  getByJob(jobId: number) {
    return new Promise<Array<IXOM>>((resolve: any, reject: any) => {      
      let uri = `${this.ixomBasURL}/ixom/api/customer/job`;
      let result = null;
      return this.http
        .get(uri, { params: { jobId: jobId} })
        .toPromise()
        .then(data => {
          result = data.json();
          resolve(result);
        })
        .catch(          
          err => {
            resolve([]);
          }
        )
    });
  }

  getByJobHistory(jobId: number) {
    return new Promise<Array<IXOM>>((resolve: any, reject: any) => {      
      let uri = `${this.ixomBasURL}/ixom/api/customer/jobhistory`;
      let result = null;
      return this.http
        .get(uri, { params: { jobId: jobId} })
        .toPromise()
        .then(data => {
          result = data.json();
          resolve(result);
        })
        .catch(          
          err => {
            resolve([]);
          }
        )
    });
  }

  getByJobHistorySA(jobId: number) {
    return new Promise<Array<IXOM>>((resolve: any, reject: any) => {      
      let uri = `${this.ixomBasURL}/ixom/api/customer/jobhistorysa`;
      let result = null;
      return this.http
        .get(uri, { params: { jobId: jobId} })
        .toPromise()
        .then(data => {
          result = data.json();
          resolve(result);
        })
        .catch(          
          err => {
            resolve([]);
          }
        )
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/ixom/ixom.ts